import Dialog from 'global/guides/Dialog'
import { useEscalasOutletContext } from 'pages/Escalas.context'
import { Outlet, useParams } from 'react-router-dom'
import FormularioAssocioarFuncionarioEscala from '../forms/AssociarFuncionario'

export default function AssociarFuncionarios() {
    const { id } = useParams()
    const { data } = useEscalasOutletContext()

    const exists = data?.find(item => item.id === Number(id))

    if (!exists) return null

    return (
        <Dialog.Root width="4xl">
            <Dialog.Title wrap action="Funcionários da escala">
                {exists.descricao}
            </Dialog.Title>
            <Dialog.Content>
                <FormularioAssocioarFuncionarioEscala />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton>
                    Fechar
                </Dialog.Actions.SecondaryButton>
            </Dialog.Actions>
            <Outlet />
        </Dialog.Root>
    )
}
